export const getFirstAndLastDayOfThisMonth = () => {
  const today = new Date();
  const firstDayOfMonth = new Date(Date.UTC(today.getFullYear(), today.getMonth(), 1)).toISOString().split('T')[0];
  const lastDayOfMonth = new Date(Date.UTC(today.getFullYear(), today.getMonth() + 1, 0)).toISOString().split('T')[0];
  return { firstDayOfMonth, lastDayOfMonth };
};
